import { ChartMetricsEnum } from '../../Reports/enums/chart-metrics.enum';

export enum SocialMetricAnalysisTypesEnum {
    volume,
    impressions,
    ave,
    engagements,
    applause,
    conversation,
    amplification
}


export const chartMetricToSocialMetricAnalysisTypesMap = new Map<ChartMetricsEnum, SocialMetricAnalysisTypesEnum>([
    [ChartMetricsEnum.VOLUME, SocialMetricAnalysisTypesEnum.volume],
    [ChartMetricsEnum.ave, SocialMetricAnalysisTypesEnum.ave],
    [ChartMetricsEnum.audienceReach, SocialMetricAnalysisTypesEnum.impressions],
    [ChartMetricsEnum.IMPRESSIONS, SocialMetricAnalysisTypesEnum.impressions],
    [ChartMetricsEnum.ENGAGEMENTS, SocialMetricAnalysisTypesEnum.engagements],
    [ChartMetricsEnum.APPLAUSE, SocialMetricAnalysisTypesEnum.applause],
    [ChartMetricsEnum.CONVERSATION, SocialMetricAnalysisTypesEnum.conversation],
    [ChartMetricsEnum.AMPLIFICATION, SocialMetricAnalysisTypesEnum.amplification]
]);
